import React, { useEffect } from "react";
import UploaderComponent from "./FormsUploaderComponent.js";
import LightBoxManager from "components/Structure/LightBoxManager/LightBoxManager.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import config from "config";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";
import { useContent } from "contexts/contentContext/contentContext.js";

import "./formsuploader.scss";

const UploaderWrapper = ({ mailId, setFinishUpload, embedDesign }) => {
  const { setUploadId, setMailId, getMailId, setToken, setIsJMPay, setIsUppy } =
    useUploader();
  const { getPath } = useContent();

  const handleGetStatus = async () => {
    const response = await apiRequest("Mails", "ReactGetUploadInfo", {
      encryptedMailId: mailId,
    });
    if (response.status === "success") {
      setToken(response.data.csrf);
      setIsJMPay(response.data.isJumboPay);
    } else {
      window.location.href = config.baseurl + getPath() + "error";
    }
  };

  useEffect(() => {
    setUploadId(mailId);
    setMailId(mailId);
    setIsUppy(false);
    handleGetStatus();
  }, []);

  return getMailId() ? (
    <>
      <LightBoxManager ignoreUrl={true} />
      <UploaderComponent {...{ setFinishUpload, embedDesign }} />
    </>
  ) : null;
};

export default UploaderWrapper;
